import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';
import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import { useRejectionReasonOptions } from './useRejectionReasonOptions';

type RejectionReasonSelectProps = {
  tripId: string;
  value?: string;
  onChange: (value: SelectOption | undefined) => void;
};

export function RejectionReasonSelect({
  tripId,
  value,
  onChange = () => {},
}: RejectionReasonSelectProps) {
  const { options, isLoading } = useRejectionReasonOptions(tripId);
  return (
    <Select
      options={options}
      value={value}
      disabled={options.length === 0}
      placeholder={
        isLoading
          ? 'Loading options...'
          : options.length === 0
            ? 'No valid reasons'
            : 'Select a reason'
      }
      onChange={onChange}
    />
  );
}
